import { mdiCheck, mdiClockOutline, mdiClose } from '@mdi/js';
import { ChipProps } from '@mui/material/Chip';

import { IBudgetRequestStatus } from 'graphql/types';
import { TBudgetRequestTimeLineStepColor } from 'budget/components/BudgetRequestTimeLine';

// Requests still awaiting a decision from a manager or HR.
export const PENDING_BUDGET_REQUEST_STATUSES: IBudgetRequestStatus[] = [
    IBudgetRequestStatus.PendingManager,
    IBudgetRequestStatus.PendingHr,
];

// Statuses shown in the approval table by default
export const DEFAULT_BUDGET_APPROVAL_STATUSES: IBudgetRequestStatus[] =
    PENDING_BUDGET_REQUEST_STATUSES;

export const BUDGET_APPROVAL_ROLE = {
    All: 'all',
    Manager: 'manager',
    Hr: 'hr',
} as const;

// All budget request statuses, in the order shown in the user status filter.
export const BUDGET_REQUEST_STATUSES: IBudgetRequestStatus[] = [
    IBudgetRequestStatus.PendingManager,
    IBudgetRequestStatus.PendingHr,
    IBudgetRequestStatus.ApprovedByManager,
    IBudgetRequestStatus.ApprovedByHr,
    IBudgetRequestStatus.RejectedByManager,
    IBudgetRequestStatus.RejectedByHr,
];

interface IBudgetRequestStatusConfig {
    chipColor: ChipProps['color'];
    timelineColor: TBudgetRequestTimeLineStepColor;
    iconPath: string;
    labelKey: string;
}

export const BUDGET_REQUEST_STATUS_CONFIG: Record<
    IBudgetRequestStatus,
    IBudgetRequestStatusConfig
> = {
    [IBudgetRequestStatus.ApprovedByHr]: {
        chipColor: 'success',
        timelineColor: 'success',
        iconPath: mdiCheck,
        labelKey: 'budgetRequestStatus.approvedByHr',
    },
    [IBudgetRequestStatus.ApprovedByManager]: {
        chipColor: 'success',
        timelineColor: 'success',
        iconPath: mdiCheck,
        labelKey: 'budgetRequestStatus.approvedByManager',
    },
    [IBudgetRequestStatus.PendingHr]: {
        chipColor: 'warning',
        timelineColor: 'primary',
        iconPath: mdiClockOutline,
        labelKey: 'budgetRequestStatus.pendingHr',
    },
    [IBudgetRequestStatus.PendingManager]: {
        chipColor: 'warning',
        timelineColor: 'primary',
        iconPath: mdiClockOutline,
        labelKey: 'budgetRequestStatus.pendingManager',
    },
    [IBudgetRequestStatus.RejectedByHr]: {
        chipColor: 'error',
        timelineColor: 'error',
        iconPath: mdiClose,
        labelKey: 'budgetRequestStatus.rejectedByHr',
    },
    [IBudgetRequestStatus.RejectedByManager]: {
        chipColor: 'error',
        timelineColor: 'error',
        iconPath: mdiClose,
        labelKey: 'budgetRequestStatus.rejectedByManager',
    },
};
